module.exports = __webpack_public_path__ + "static/media/r1.fd7677c0.jpg";